<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">

            <!-- FILTRO SUPERIOR -->
            <div class="filtro-dash">
              <div>

                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{ 'businessIntelligence.relatorioOportunidade.dealers' }}
                </div>

                <span
                  class="btn btn-outline-info btn-sm"
                  *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;"
                  (click)="removerDealer(dealer)"
                >
                  {{ dealer.nome }}
                  <i class="fa fa-times" aria-hidden="true"></i>
                </span>

                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>

                <div class="clear"></div>
              </div>
            </div>

            <hr>

            <!-- FILTROS DE DATA -->
            <div class="row ptb50">

              <div class="col col-4">
                <div translate class="filtro" style="margin: 0px 10px 0px 0px;">
                  {{ 'businessIntelligence.relatorioOportunidade.dataInicial' }}
                </div>

                <p-calendar
                  [(ngModel)]="dataInicial"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  (onClearClick)="limpaDataInicial()"
                  placeholder="{{ 'businessIntelligence.relatorioOportunidade.dataInicialPlaceHolder' | translate }}"
                  showButtonBar="true"
                ></p-calendar>
              </div>

              <div class="col col-4">
                <div translate class="filtro" style="margin: 0px 10px 0px 0px;">
                  {{ 'businessIntelligence.relatorioOportunidade.dataFinal' }}
                </div>

                <p-calendar
                  [(ngModel)]="dataFinal"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  (onClearClick)="limpaDataFinal()"
                  placeholder="{{ 'businessIntelligence.relatorioOportunidade.dataFinalPlaceHolder' | translate }}"
                  showButtonBar="true"
                ></p-calendar>
              </div>

              <div class="col col-4">
                <button
                  translate
                  type="button"
                  class="btn btn-primary mt-3 mr-2"
                  (click)="filtroAPI()"
                >
                  {{ 'businessIntelligence.relatorioOportunidade.filtrar' }}
                  <i class="fas fa-search"></i>
                </button>

                <button
                  pButton
                  class="p-button-outlined p-button-secondary p-button-sm float-right mt-3"
                  type="button"
                  (click)="exportExcel()"
                  [disabled]="!relatorioOportunidadeDados?.length"
                >
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>

            </div>

            <!-- Botões para alternar tipo de análise -->
                  <div class="row mt-3">
                    <div class="col col-lg-8 col-md-12">
                      <div class="d-flex flex-wrap">

                        <button
                          pButton
                          type="button"
                          (click)="alterarFiltro('todos')"
                          [class.p-button-primary]="filtroAtivo === 'todos'"
                          [class.p-button-outlined]="filtroAtivo !== 'todos'"
                          class="p-button-sm p-button-secondary mr-2 mb-2 d-flex justify-content-center align-items-center"
                          style="min-width: 120px;">
                          {{ 'businessIntelligence.relatorioOportunidade.filtros.todos' | translate }}
                        </button>

                        <button
                          pButton
                          type="button"
                          (click)="alterarFiltro('comPlanoManutencao')"
                          [class.p-button-primary]="filtroAtivo === 'comPlanoManutencao'"
                          [class.p-button-outlined]="filtroAtivo !== 'comPlanoManutencao'"
                          class="p-button-sm p-button-secondary mr-2 mb-2 d-flex justify-content-center align-items-center"
                          style="min-width: 120px;">
                          {{ 'businessIntelligence.relatorioOportunidade.filtros.comPlanoManutencao' | translate }}
                        </button>

                        <button
                          pButton
                          type="button"
                          (click)="alterarFiltro('semPlanoManutencao')"
                          [class.p-button-primary]="filtroAtivo === 'semPlanoManutencao'"
                          [class.p-button-outlined]="filtroAtivo !== 'semPlanoManutencao'"
                          class="p-button-sm p-button-secondary mb-2 d-flex justify-content-center align-items-center"
                          style="min-width: 120px;">
                          {{ 'businessIntelligence.relatorioOportunidade.filtros.semPlanoManutencao' | translate }}
                        </button>

                      </div>
                  </div>
                </div>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <!-- LOADING INICIAL -->
    <div class="d-flex justify-content-center">
      <div *ngIf="cargaTela">
        <div class="w-100 d-flex justify-content-center mt-4">
          <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <label>Loading...</label>
        </div>
      </div>
    </div>

    <!-- SEM REGISTROS -->
    <div
      translate
      *ngIf="relatorioOportunidadeDados?.length <= 0 && !cargaTela"
      class="sem-registros text-muted mt-2"
    >
      {{ 'businessIntelligence.relatorioOportunidade.nenhumRegistroExibir' }}
    </div>

    <!-- TABELA PRINCIPAL -->
    <p-table
      #dt
      *ngIf="relatorioOportunidadeDados?.length > 0"
      [value]="relatorioOportunidadeDados"
      [columns]="cols"
      dataKey="id"
      selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm"
      [paginator]="relatorioOportunidadeDados?.length > 10"
      [rows]="10"
      [loading]="loading"
      [autoLayout]="true"
      currentPageReportTemplate="{{ 'businessIntelligence.relatorioOportunidade.mostrandoRegistros' | translate }}"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10,20,30,50,100]"
      [globalFilterFields]="[
        'chassi_completo','data_criacao','dealer','plano_manutencao','primeira_revisao',
        'segunda_revisao','terceira_revisao','quarta_revisao','quinta_revisao'
      ]"
      id="excel-table"
    >

      <!-- TOP BAR -->
      <ng-template pTemplate="caption">
        <div class="table-header">

          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{ 'businessIntelligence.relatorioOportunidade.filtroGeral' | translate }}"
            />
          </span>

          <!-- SELECTOR DE COLUNAS -->
          <p-multiSelect
            *ngIf="this.translate.currentLang == 'br'"
            [options]="cols"
            [(ngModel)]="selectedColumns"
            optionLabel="headerBr"
            selectedItemsLabel="{{ 'businessIntelligence.relatorioOportunidade.colunasSelecionadas' | translate }}"
            [style]="{ minWidth: '200px' }"
            placeholder="{{ 'businessIntelligence.relatorioOportunidade.colunasSelecionadasPlaceHolder' | translate }}"
          ></p-multiSelect>

          <p-multiSelect
            *ngIf="this.translate.currentLang == 'gb'"
            [options]="cols"
            [(ngModel)]="selectedColumns"
            optionLabel="headerGb"
            selectedItemsLabel="{{ 'businessIntelligence.relatorioOportunidade.colunasSelecionadas' | translate }}"
            [style]="{ minWidth: '200px' }"
            placeholder="{{ 'businessIntelligence.relatorioOportunidade.colunasSelecionadasPlaceHolder' | translate }}"
          ></p-multiSelect>

        </div>
      </ng-template>

      <!-- HEADER -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">

            <th
              class="text-center"
              *ngIf="col.field == 'detalhe'"
              [translate]="getTranslate(col.header)"
              style="background-color:black;color:white;"
            >
              {{ col.header }}
            </th>

            <th
              *ngIf="col.field != 'detalhe'"
              class="text-center"
              [translate]="getTranslate(col.header)"
              [pSortableColumn]="col.field"
              style="background-color:black;color:white;"
            >
              {{ col.header }}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="sort" />
            </th>

          </ng-container>
        </tr>
      </ng-template>

      <!-- BODY -->
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.field != 'detalhe'" class="text-center">
              <div [ngClass]="{ 'dealer': col.field === 'nome' }">
                {{ col.type ? col.type.transform(row[col.field], col.arg1) : row[col.field] }}

                <ng-container *ngIf="col.field === 'status'" [translate]="getTranslate(row)">
                </ng-container>
              </div>
            </td>
          </ng-container>
        </tr>
      </ng-template>

    </p-table>

  </div>
</div>


<!-- COMPONENTE DE FILTRO DE DEALERS -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)"
>
</app-filtro-dealers>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast>
